import dayjs from "dayjs";

// La investigación se considera concluida (sólo lectura) cuando ya llegó el día
// de la fecha de conclusión. Una fecha futura aún permite editar; ese día se cierra.
export const isInvestigationConcluded = (conclusionAt) => {
  if (!conclusionAt) return false;
  const date = dayjs(conclusionAt);
  if (!date.isValid()) return false;
  return !dayjs().isBefore(date, "day");
};
